import React, { useEffect, useState, useMemo } from 'react';
import ReactTable from 'react-table';
import moment from 'moment';
import { Card, CardBody } from 'reactstrap';
import { AxiosAPI, getUserID } from '../../../../../../helpers/AxiosAPI';
import { gAPI_User_SignIn_Logs_Sp } from '../../../../../../constants/APIs';
import GroupTablePagination from '../../../../../../components/GroupTablePaginate';
const pageSize = 25;

const SignInLogs = () => {
  const [logs, setLogs] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [loading, setLoading] = useState(false);

  // FETCH LOGS (USER BASED)
  const fetchLogs = async (page = 1) => {
    try {
      setLoading(true);

      const response = await AxiosAPI({
        method: 'get',
        url: gAPI_User_SignIn_Logs_Sp,
        params: {
          userId: getUserID(),
          pageNumber: page,
          pageSize,
        },
      });

      const data = response?.data;

      setLogs(data?.logs || []);
      setTotalCount(data?.totalItems || 0);
    } catch (err) {
      console.error('SP Logs Error:', err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs(1);
  }, []);

  const totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
  // FORMAT DATA
  const formattedLogs = useMemo(
    () =>
      logs.map((log) => ({
        userName: log.userName || '-',
        email: log.email || '-',
        groupName: log.groupName || log.groupId || '-',
        propertyName: log.propertyName || log.propertyId || '-',
        loginTime: log.signedInUtc
          ? moment.utc(log.signedInUtc).local().format('MMM DD, YYYY hh:mm a')
          : '-',
      })),
    [logs]
  );

  // TABLE COLUMNS
  const columns = useMemo(
    () => [
      { Header: 'User Name', accessor: 'userName' },
      { Header: 'Email', accessor: 'email' },
      { Header: 'Group', accessor: 'groupName' },
      { Header: 'Property', accessor: 'propertyName' },
      { Header: 'Login Time', accessor: 'loginTime' },
    ],
    []
  );

  return (
    <Card>
      <CardBody>
        {
          <ReactTable
            data={formattedLogs}
            columns={columns}
            pages={totalPages}
            loading={loading}
            manual
            defaultPageSize={pageSize}
            className="-striped -highlight"
            PaginationComponent={GroupTablePagination}
            showPageJump={true}
            showPageSizeOptions={false}
            onFetchData={(state) => {
              fetchLogs(state.page + 1);
            }}
          />
        }
      </CardBody>
    </Card>
  );
};

export default SignInLogs;
